var exports = {
  "kL": "x52a3aa3b--d55867--container",
  "ik": "x52a3aa3b--d55867--place",
  "du": "x52a3aa3b--d55867--gpt-button",
  "BF": "x52a3aa3b--d55867--utilities",
};

module.exports = exports;
